<script>
	import {onMount} from "svelte";
	import {LmsUtils} from "../utils/LmsUtils";
	import {External, M} from "../../external";
	import {ignore} from "../../Common/tools";
	import {makeLmsRequest} from "../service/LmsClient";
	import Loader from "../../Common/Loader.svelte";

	export let circle, memberDetails, contactId, memberId;
	let showingAllCircles = false;
	let circleDetails = [];
	let productIds = [];
	let products = {};
	let paymentItemsCount = 0;
	let loading = true;

	let toDateString = timeStr => {
		return External.Tools.dateToString(new Date(timeStr), false, false, true);
	}

	let addIfPaid = (target, item, type, name) => {
		if (item.access?.type === "PAID") {
			let access = memberDetails.access.find(access => access.itemId === item.id);
			++paymentItemsCount;
			target.push({
				id: item.id,
				name: name,
				type: type,
				paid: !!access?.paid,
				paidOn: access?.paidOn || '',
				productId: item.access.productId
			});
			if (item.access.productId) {
				productIds.push(item.access.productId);
			}
		}
	}

	let setPaid = (circle, item, paid) => {
		const message = External.format(paid ? M.GIVE_ACCESS_QUESTION : M.REVOKE_ACCESS_QUESTION, 'x', item.name);
		External.Tools.prompt("", message, async () => {
			const endpoint = `/circle/${circle.id}/paid/${item.type}/${item.id}/${contactId}/${memberId}`;
			let response = await makeLmsRequest(endpoint, paid ? 'POST' : 'DELETE');
			if (response.ok) {
				let access = await response.json();
				item.paid = paid;
				let accessIdx = memberDetails.access.findIndex(access => access.itemId === item.id);
				if (accessIdx >= 0) {
					if (access) {
						memberDetails.access[accessIdx] = access;
					} else {
						memberDetails.access.splice(accessIdx, 1);
					}
				} else if (access) {
					memberDetails.access.push(access);
				}
				circleDetails = circleDetails;
			}
		}, ignore);
	}

	onMount(async () => {
		showingAllCircles = !circle.id;
		let circlesToUse;
		if (showingAllCircles) {
			circlesToUse = memberDetails.circles;
		} else {
			circlesToUse = memberDetails.circles.filter(details => details.circle.id === circle.id);
		}

		circleDetails = circlesToUse.map(details => {
			let ordered = LmsUtils.getPagesAndGroupsInOrder(details);
			let orderedWithPayment = [];

			addIfPaid(orderedWithPayment, details.circle, 'circle', details.circle.name);

			for (let idx = 0; idx < ordered.length; idx++) {
				let item = ordered[idx];
				if (item.pageGroup) {

					addIfPaid(orderedWithPayment, item.pageGroup, 'group', details.circle.name + ' > ' + item.pageGroup.name);

					for (let pageIdx = 0; pageIdx < item.pages.length; pageIdx++) {
						let page = item.pages[pageIdx];
						addIfPaid(orderedWithPayment, page, 'page', details.circle.name + ' > ' + item.pageGroup.name + ' > ' + page.name);
					}
				} else {
					addIfPaid(orderedWithPayment, item, 'page', details.circle.name + ' > ' + item.name);
				}
			}

			return {
				circle: details.circle,
				items: orderedWithPayment
			};
		});

		products = await LmsUtils.getProductsById(productIds);
		loading = false;
	})
</script>
<div class="scrollable-table orders-scrollable-table scrollable-table-design strnger-border">
	{#if loading}
		<Loader compact={true}/>
	{:else}
		{#if paymentItemsCount === 0}
			{M.NO_PAID_CONTENT_AVAILABLE}
		{:else}
			<table style="margin-top: 0px;">
				<thead>
				<tr class="flex flex-row align-center" style="padding-bottom: 0px;">
					<th class="flex-none mw-300" style="padding-left: 20px;"><a>{M.NAME}</a></th>
		            <th class="flex-none mw-120">{M.PRICE}</th>
		            <th class="flex-none"><a>{M.TYPE}</a></th>
		            <th class="flex-none mw-120"><a>{M.STATUS}</a></th>
		            <th class="flex-none"><a>{M.PURCHASE_DATE}</a></th>
				</tr>
				</thead>
				<tbody style="height: auto;">
				{#each circleDetails as detail}
					{#each detail.items as item}
						<tr class="flex flex-row align-center">
							<td class="flex-none mw-300" style="padding-left: 20px;">{item.name}</td>
							<td class="flex-none mw-120">
								{#if item.productId && products[item.productId]}
									{External.Tools.currencyToStrWithSymbol(products[item.productId].price)}
								{:else}
									-
								{/if}
							</td>
							<td class="flex-none">
								{item.type === 'circle' ? M.CIRCLE : item.type === 'group' ? M.GROUP : M.PAGE}
							</td>
							<td class="flex-none mw-120">
								{#if item.paid && item.paidOn}
									<span class="pay-status paid">{M.PAID}</span>
								{:else if item.paid}
									<a class="pay-status paid" on:click={() => setPaid(detail.circle, item, false)}>{M.MANUAL}</a>
								{:else}
									<a class="pay-status not-paid" on:click={() => setPaid(detail.circle, item, true)}>+ {M.GIVE_ACCESS}</a>
								{/if}
							</td>
							<td class="flex-none">
								{item.paid && item.paidOn ? toDateString(item.paidOn) : '-'}
							</td>
						</tr>
					{/each}
				{/each}
				</tbody>
			</table>
		{/if}
	{/if}
</div>

